export const VALIDATION_MESSAGES = {
  common: {
    required: 'The field is required',
    minLength: (minLength) =>
      `The field must contain at least ${minLength} characters`,
    maxLength: (maxLength) =>
      `The field must contain no more than ${maxLength} characters`,
    atLeastOneLetter: 'The field must contain at least one letter',
    noSpacesAtEdges:
      'The field must not contain spaces at the beginning or at the end'
  },
  email: {
    invalid: 'The e-mail is invalid'
  },
  userName: {
    allowedCharactersHTML: `The field must contain only <b>letters</b>, <b>digits</b>, <b>space</b> character,
                            <kbd>-</kbd> (<b>hyphen</b>), <kbd>'</kbd> (<b>quote</b>) or <kbd>.</kbd> (<b>period</b>)`
  },
  companyPrefixURL: {
    allowedCharacters:
      'The field must contain only <b>lowercase latin letters</b>, <b>digits</b> and <kbd>-</kbd> (<b>hyphen</b>)'
  },
  universalNameValidation: `Name must be 3–70 characters, include at least one letter, and may use spaces (not at start/end), <kbd>-</kbd> (<b>hyphen</b>), <kbd>'</kbd> (<b>quote</b>) and <kbd>.</kbd> (<b>period</b>)`
}
